const matchPlayPage = {
  "match-play.header-title": "Match Play",
  "match-play.title": "Rise Under Pressure",
  "match-play.subtitle": "Match Play AI Mode",
  "match-play.description": "Just you, the ball, and relentless AI-driven play. Show what you’ve got—when it counts.",
  "match-play.game-speed": "Game Speed",
  "match-play.difficulty": "Difficulty",
  "match-play.game-duration": "Game Duration",
  "match-play.playing-position": "Playing Position",
  "match-play.your-position": "Your Position",
};

const settings = {
  "match-play.settings.speed.slow": "Slow",
  "match-play.settings.speed.normal": "Normal",
  "match-play.settings.speed.fast": "Fast",
};

const difficulty = {
  "match-play.settings.difficulty.beginner": "Beginner",
  "match-play.settings.difficulty.easy": "Easy",
  "match-play.settings.difficulty.medium": "Medium",
  "match-play.settings.difficulty.hard": "Hard",
  "match-play.settings.difficulty.expert": "Expert",
};

export const matchPlay = {
  ...matchPlayPage,
  ...settings,
  ...difficulty,
};
